import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Card, Typography, Button, Icon, IconButton } from '@material-ui/core';
import {
  getTierSubscriptionPlansApi,
  deleteSubscriptionTierApi
} from 'api';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NumberFormat from 'react-number-format';


const useStyles = makeStyles((theme) => ({
  tierItem: {
    marginBottom: 5,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  plansForm: {
    '& div': {
      color: '#000000 !important'
    }
  }
}));


const TiersList = ({setTier}) => {
  const [expanded, setExpanded] = useState();
  const classes = useStyles();
  const dispatch = useDispatch();
  const {subscriptionTiers, profile} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};

  useEffect(() => {
    getTierSubscriptionPlansApi({dispatch});
  }, []);

  const handleChangeActive = (id) => {
    setExpanded(expanded !== id ? id : null);
  };

  return (
    <div>
      {subscriptionTiers.map((tier) => {
        return (
          <Accordion key={tier._id} className={classes.tierItem} expanded={expanded === tier._id} onChange={() => handleChangeActive(tier._id)}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography className={classes.heading}>{tier.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <form className={classes.plansForm}>
                <Typography variant="h4" className="mt-8 mb-4">Available Subscription Plans: </Typography>
                <div className="flex items-center">
                  {tier.plans.map((plan, idx) => {
                    return (
                      <Card
                        key={`plan-${plan._id}`}
                        className="w-full p-4 m-4"
                        elevation={25}
                      >
                        <TextField
                          className="my-2"
                          name={`plans.${idx}.title`}
                          label="Subscription Plan Title"
                          required
                          fullWidth
                          value={plan.title}
                          variant="outlined"
                          disabled
                        />
                        <NumberFormat
                          thousandSeparator
                          className="my-2"
                          prefix="$ "
                          variant="outlined"
                          fullWidth
                          decimalScale={2}
                          disabled
                          customInput={TextField}
                          name={`plans.${idx}.price`}
                          label="Plan Start Price"
                          value={plan.price}
                        />
                        <NumberFormat
                          thousandSeparator
                          className="my-2"
                          variant="outlined"
                          fullWidth
                          decimalScale={2}
                          disabled
                          customInput={TextField}
                          name={`plans.${idx}.planPaymentPeriod`}
                          label="Monthly Paid Period"
                          value={plan.months}
                        />
                        <NumberFormat
                          thousandSeparator
                          className="my-2"
                          variant="outlined"
                          fullWidth
                          decimalScale={2}
                          disabled
                          customInput={TextField}
                          name={`plans.${idx}.planSavings`}
                          label="Percent Discount"
                          value={plan.savings}
                          suffix=" %"
                        />
                        <NumberFormat
                          thousandSeparator
                          className="my-2"
                          prefix="$ "
                          variant="outlined"
                          fullWidth
                          decimalScale={2}
                          disabled
                          customInput={TextField}
                          name={`plans.${idx}.planPriceDueToday`}
                          label="Plan Price Due Today"
                          value={plan.priceDueToday}
                        />
                        <NumberFormat
                          thousandSeparator
                          className="my-2"
                          variant="outlined"
                          fullWidth
                          disabled
                          customInput={TextField}
                          name={`plans.${idx}.promoSkusLimit`}
                          label="Promo SKUS limit"
                          value={plan.promoSkusLimit}
                        />
                        <NumberFormat
                          thousandSeparator
                          className="my-2"
                          variant="outlined"
                          fullWidth
                          disabled
                          customInput={TextField}
                          name={`plans.${idx}.promosPerMonthLimit`}
                          label="Promos per month limit"
                          value={plan.promosPerMonthLimit}
                        />
                      </Card>
                    );
                  })}
                </div>
                <div className="flex items-center justify-between mt-8">
                  {permissions?.adminSubscriptionTierEdit &&
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setTier(tier)}
                  >
                    Edit
                  </Button>}
                  {permissions?.adminSubscriptionTierRemove &&
                  <IconButton
                    className="mr-2"
                    title="Delete"
                    onClick={() => deleteSubscriptionTierApi({ dispatch, id: tier._id})}
                  >
                    <Icon className="text-gray">delete</Icon>
                  </IconButton>}
                </div>
              </form>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

export default TiersList;
